import Link from 'next/link'
import styles from './styles.module.scss'
import { formatCurrency2String } from 'src/utils/number/currency'
import { simplifyUrl } from 'src/utils/url'
import { intl } from 'src/i18n'

type Extra = {
  established?: string
  website?: string
  description?: string
}

type Props = {
  data: {
    adjustedVolume: number
    coins: number
    country: string
    name: string
    coreType: string
    pairs: number
    reportedVolume: number
    extra: Extra
  }
}

export const ExchangeAbout = ({ data }: Props) => {
  const {
    adjustedVolume,
    coins,
    extra,
    country,
    name,
    coreType,
    pairs,
    reportedVolume,
  } = data
  const { established, website, description } = extra || {}

  const checkValue = value => value || '?'

  const renderPairsBlock = pairs => {
    return (
      <>
        {' '}
        and
        <span className={styles.aboutWhite}>
          {' '}
          {checkValue(pairs)} trading pairs
        </span>
      </>
    )
  }

  const volume = reportedVolume < 0 ? adjustedVolume : reportedVolume

  return (
    <div className={styles.exchangeAbout}>
      <div className={styles.aboutHeader}>{`About ${checkValue(name)}`}</div>
      <div className={styles.aboutText}>
        <span className={styles.aboutWhite}>{checkValue(name)}</span>
        {intl.t('exchangeDetails.components.exchangeAbout.about1')}
        <span className={styles.aboutWhite}>
          {' '}
          {checkValue(coreType.toLowerCase())}
        </span>
        {intl.t('exchangeDetails.components.exchangeAbout.about2')}
        <span className={styles.aboutWhite}> {checkValue(country)}</span>
        {intl.t('exchangeDetails.components.exchangeAbout.about3')}
        <span className={styles.aboutWhite}>
          {' '}
          ${checkValue(formatCurrency2String(volume, false, '0,0'))}
        </span>
        {intl.t('exchangeDetails.components.exchangeAbout.about4')}
        <span className={styles.aboutWhite}> {checkValue(coins)}</span>
        {intl.t('exchangeDetails.components.exchangeAbout.about5')}
        {pairs > 0 && renderPairsBlock(pairs)}. {name}{' '}
        {intl.t('exchangeDetails.components.exchangeAbout.about6')}
        <span className={styles.aboutWhite}> {checkValue(established)}</span>.
        {intl.t('exchangeDetails.components.exchangeAbout.about7', {
          checkValueName: checkValue(name),
        })}
        {website ? (
          <Link href={website} legacyBehavior>
            <a
              rel='noopener noreferrer'
              className={styles.exchangeAboutLink}
              target='_blank'
            >
              &nbsp;{simplifyUrl(website).replace('www.', '')}{' '}
            </a>
          </Link>
        ) : (
          <span className={styles.exchangeAboutLink}>&nbsp;?</span>
        )}
        {description && (
          <div
            className={styles.extraAboutText}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
      </div>
    </div>
  )
}

export default ExchangeAbout
